function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.87906 16.0312H3.5625C3.40503 16.0312 3.25401 15.9687 3.14266 15.8573C3.03131 15.746 2.96875 15.5949 2.96875 15.4375V12.1209C2.96875 12.0429 2.98411 11.9657 3.01395 11.8937C3.04379 11.8217 3.08752 11.7562 3.14266 11.7011L12.0489 2.79482C12.1603 2.68347 12.3113 2.62091 12.4688 2.62091C12.6262 2.62091 12.7772 2.68347 12.8886 2.79482L16.2052 6.11138C16.3165 6.22273 16.3791 6.37375 16.3791 6.53122C16.3791 6.68869 16.3165 6.83972 16.2052 6.95107L7.29891 15.8573C7.24377 15.9125 7.17832 15.9562 7.10628 15.986C7.03424 16.0159 6.95703 16.0312 6.87906 16.0312Z",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0938 4.75L14.25 8.90625",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.08702 15.9933L3.00647 11.9128",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/Rename.9a0e1b3f2353b0fff3955f1914ce5d10.svg";
export { ForwardRef as ReactComponent };